import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen grain">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" className="text-xs uppercase tracking-widest text-zinc-500 hover:text-white inline-flex items-center gap-1 mb-8">
          <ArrowLeft className="w-3 h-3" /> Back
        </Link>
        <div className="text-[10px] tracking-[0.3em] uppercase text-fuchsia-400 font-semibold">Xhat</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Privacy Policy</h1>
        <p className="text-xs text-zinc-500 mt-2">Last updated: February 2026</p>

        <div className="prose prose-invert mt-10 text-zinc-300 leading-relaxed space-y-6 max-w-none">
          <p>
            Xhat (&ldquo;we&rdquo;, &ldquo;us&rdquo;) is built on privacy and discretion.
            This policy describes what we collect, why, and the control you have over it.
          </p>

          <Section title="1. What we collect">
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Account info</strong> — email (only if you register), username, password hash, and optional profile fields: bio, age, location, pronouns, avatar.</li>
              <li><strong>Guest identity</strong> — if you enter as a guest, we store only a username and a randomly generated ID. No email is collected.</li>
              <li><strong>Chat messages</strong> — stored so that people joining a room can see recent history. You can delete your own messages at any time.</li>
              <li><strong>Video calls</strong> — peer-to-peer. Audio and video are <strong>never</strong> recorded, transmitted through, or stored by our servers.</li>
              <li><strong>Moderation data</strong> — reports you submit and users you block, used only to keep the community safe.</li>
            </ul>
          </Section>

          <Section title="2. What we don't do">
            <ul className="list-disc pl-6 space-y-2">
              <li>We do not sell your data.</li>
              <li>We do not run advertising trackers.</li>
              <li>We do not share your email or profile with third parties except as required by law.</li>
              <li>We do not record video calls.</li>
            </ul>
          </Section>

          <Section title="3. Your rights">
            You can edit your profile, delete your account, export your data, or block and report any user at any time from inside the app. Deletion is permanent and removes your messages.
          </Section>

          <Section title="4. Community safety">
            Hate speech, harassment, threats, doxxing, and sexual content involving minors are strictly prohibited and removed. We cooperate with law enforcement when required.
          </Section>

          <Section title="5. Age">
            Xhat is for users 18 and older. If we learn that a user under 18 has created an account we will remove it.
          </Section>

          <Section title="6. Contact">
            For any privacy question, email <a href="mailto:keandreleams@gmail.com" className="text-fuchsia-400 hover:text-fuchsia-300">keandreleams@gmail.com</a>.
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl font-bold tracking-tight text-white mb-3">{title}</h2>
      <div>{children}</div>
    </div>
  );
}
